<ion-list class="menu-list">
  <ion-item *ngFor="let button of buttons;" (click)="clickMenu(button)" class="pointer" detail-none>
    <img *ngIf="button.img" height="24" width="24" src="{{button.img}}">
    <ion-icon *ngIf="button.icon" class="pop-menu-icon" height="24" width="24" name="{{button.icon.name}}" color="{{button.icon.color}}"></ion-icon>
    {{button.name || button.text}}
  </ion-item>
</ion-list>